import useMutationApi from 'src/api/useMutationApi';

const useSendEdi856Transaction = (onSuccess?: () => void) => {
  return useMutationApi<{ famousShipmentId: string }>({
    endpoint: 'famous/shipments/send-edi-856',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useSendEdi856Transaction;
